'use strict'

function Interceptor ($httpProvider) {
  $httpProvider.interceptors.push(function ($q, $location, $sessionStorage) {
    return {
      request: function (request) {
        var url = request.url
        if (
          url.indexOf('.html') === -1 &&
                    url.indexOf('/api/') !== -1
        ) {
          if (!request.headers.ignoreToken) {
            var auth = $sessionStorage.get('h4-cert-token')
            auth = JSON.parse(auth)
            request.headers.Authorization = 'Bearer ' + auth.token
          }
          delete request.headers.ignoreToken
        }

        return request || $q.when(request)
      },

      response: function (response) {
        return response || $q.when(response)
      },

      responseError: function (response) {
        if (response.status === 401) {
          alert.danger('Token de Acesso invalido - Atualize a página.')
          return $q.reject(response)
        }
        if (response.status === 403) {
          alert.danger('Acesso restrito.')
          return $q.reject(response)
        }
        if (response.data) return $q.reject(response)
      }
    }
  })
}

angular.module('app').config(Interceptor)



//////////////////
// WEBPACK FOOTER
// ./factories/httpInterceptor.js
// module id = 94
// module chunks = 0